<template>
	<div style="width: 100%;height: 100%;">
		<div style="display: flex;width: 100%;height: 100%;justify-content: space-between;background-color:#F7F7F7 ;">
			<div class="ara1">
				<div class="Centerupdown">
					<div class="backstyle" style="width: 144px;" @click="Genxssfa">更新税收分类编码</div>
					<div class="newstyle" style="margin-left: 20px;">最新</div>
					<div class="newbacktextstyle" style="margin-left: 3px;">{{timestampToTimesfm(GenXDate)}}</div>
				</div>
				<div style="border-bottom: 1px solid rgba(0,0,0,0.1);width: 100%;margin: 16px 0px 5px 0px;"></div>
				<!-- <span>编码表版本号:48.0</span> -->
				<el-tree :data="data" :props="defaultProps" accordion @node-click="handleNodeClick">
					<div class="between-line" style="width: 100%;" slot-scope="{ node, data }">
						<div>{{ data.name }}</div>
						<div v-if="data.name == '全部'">共{{ tree - 1 }}项</div>
					</div>
				</el-tree>
			</div>
			<div class="ara2">
				<div class="between-line">
					<el-input style="width:300px" placeholder="请输入税收分类编码、名称、简称、关键字、税率、说明" prefix-icon="el-icon-search"
						v-model="likeSearch" @input="forserchgroup"></el-input>
					<div>
						<img style="width: 16px;cursor: pointer;" @click="shaidiag = true" class="filterimgStyle"
							src="../../../assets/img/filterimg.svg" />
						<filterdiag :visible="shaidiag" @closediag="closeshaidiag" :fliterlist="headData"
							:outlist="outlist" @confirmfilter="confirmfilter"></filterdiag>
					</div>
				</div>
				<Taxtable :headData="headData" showPagination ref="tablebox" :tableData="tableData"
					style="margin-top: 16px;" showoverflowtooltip @sizChange="handleSizeChange"
					@currentChange="handleCurrentChange" :pagination="pagination" tableHeight="calc(100vh - 260px )"
					:tablekey="elementui_page_component_key" @forSearchScreeningBox="forSearchScreeningBox"
					@sortchange="sortchange">
					<template v-slot:shifcy="scope">
						<div>
							<img src="../../../assets/img/collect.svg" v-if="scope.taxval.shifcy == '1'" />
							<img src="../../../assets/img/nocollect.svg" v-else />
						</div>
					</template>
					<template v-slot:zzssl="scope">
						<div>{{ toPoint(scope.taxval.zzssl) }}</div>
					</template>
				</Taxtable>
			</div>
		</div>
	</div>
</template>

<script>
	var _this;
	export default {
		data() {
			return {
				GenXDate:"",
				shaidiag: false,
				outlist: [],
				headData: [{
						title: '是否常用',
						prop: 'shifcy',
						width: '120',
						custom: true,
						showFilter: true,
						checkList: [],
						dataList: [{
								name: '否',
								code: '0'
							},
							{
								name: '是',
								code: '1'
							}
						]
					},
					{
						title: '父级编码',
						prop: 'tes2',
						width: '120',
						issort: true
					},
					{
						title: '税收分类编码',
						prop: 'shuisbm',
						width: '160',
						issort: true
					},
					{
						title: '名称',
						prop: 'shangpmc',
						width: '100',
						issort: true
					},
					{
						title: '简称',
						prop: 'shangpbmjc',
						width: '100',
						issort: true
					},
					{
						title: '税率',
						prop: 'zzssl',
						width: '100',
						showFilter: true,
						checkList: [],
						dataList: [],
						align: 'right',
						custom: true
					},
					{
						title: '征收率',
						prop: 'tes7',
						width: '120',
						showFilter: true,
						checkList: [],
						dataList: [],
						align: 'right'
					},
					{
						title: '关键字',
						prop: 'guanjz',
						width: '120',
						issort: true
					},
					{
						title: '说明',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '有效期',
						prop: 'shuom',
						width: '120',
						showFilter: true,
						checkList: [],
						dataList: []
					},
					{
						title: '是否汇总项',
						prop: 'shuom',
						width: '200',
						showFilter: true,
						checkList: [],
						dataList: []
					},
					{
						title: '特定要素标签归类',
						prop: 'shuom',
						width: '200',
						showFilter: true,
						checkList: [],
						dataList: []
					},
					{
						title: '差额征税',
						prop: 'shuom',
						width: '120',
						showFilter: true,
						checkList: [],
						dataList: []
					},
					{
						title: '不征税',
						prop: 'shuom',
						width: '120',
						showFilter: true,
						checkList: [],
						dataList: []
					},
					{
						title: '即征即退',
						prop: 'shuom',
						width: '120',
						showFilter: true,
						checkList: [],
						dataList: []
					},
					{
						title: '增值税特殊管理',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '增值税政策依据',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '增值税减免稅政策代码',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '消费税管理',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '消费税政策依据',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '消费税特殊内容代码',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '对应统计局编码（2011 年版）或国民行业代码',
						prop: 'shuom',
						width: '300',
						issort: true
					},
					{
						title: '海关进出口商品品目',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '行业代码',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '对应的行业',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '行业对应的征收品目一',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '行业对应的征收名称一',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '行业对应的征收品目二',
						prop: 'shuom',
						width: '200',
						issort: true
					},
					{
						title: '行业对应的征收名称二',
						prop: 'shuom',
						width: '200',
						issort: true
					}
				],
				pagination: {
					pageNum: 1,
					pageSize: 50,
					total: 0,
					paginationkey: 0
				},

				//搜索
				likeSearch: '',
				//area1
				tableData: [], //表格数据
				elementui_page_component_key: '',
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				tree: 0,
				type: ''
			};
		},
		created() {
			_this = this;
			// this.getGoodsSWBMList();
			this.getGoodsSwbmTreeData();
			this.GteGexsjj();
		},
		mounted() {},
		methods: {
			forSearchScreeningBox(obj) {
				console.log(obj); //筛选数组
			},
			forserchgroup() {
				this.pagination.pageNum = 1;
				this.elementui_page_component_key++;
				this.getGoodsSWBMList();
			},
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.getGoodsSWBMList();
			},
			handleCurrentChange(val) {
				this.pagination.pageNum = val;
				this.getGoodsSWBMList();
			},
			//表格体 排序
			sortchange(e) {
				if (e.order != null) {
					this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
					this.order = e.prop;
				} else {
					this.sort = '';
					this.order = '';
				}
				this.getGoodsSWBMList();
			},
			/* 获取全部税收分类数据 */
			getGoodsSWBMList() {
				let params = {
					page: this.pagination.pageNum,
					limit: this.pagination.pageSize,
					likeSearch: this.likeSearch,
					type: this.type,
					sort: this.sort,
					order: this.order
				};
				this.$https.fetchPost('/master/getGoodsSwbmList', params).then(res => {
					console.log(11)
					this.tableData = res.data.data;
					this.total = res.data.count;
				});
			},
			handleNodeClick(data) {
				if (data.code != 0) {
					this.type = data.code;
					this.getGoodsSWBMList();
				}
			},
			Genxssfa() {
				this.$https.fetchPost('/master/refreshGoodsSwbmData').then(res => {
					if (res.data.code == '200') {
						this.$message.success("更新成功");
						this.getGoodsSwbmTreeData();
						this.GteGexsjj();
						this.tableData = [];
						this.total = 0;
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			GteGexsjj() {
				this.$https.fetchPost('/master/getRefreshGoodsSwbmTime').then(res => {
					if (res.data.code == '200') {
						this.GenXDate = res.data.timestamp
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//时间戳转时间
			timestampToTimesfm(timestamp) {
				// 时间戳为10位需*1000，时间戳为13位不需乘1000
				if (timestamp) {
					var date = new Date(timestamp);
					var Y = date.getFullYear() + '年';
					var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '月';
					var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + '日 ';
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					// return Y + M + D;
					return Y + M + D + h + m + s;
				}
			},
			getGoodsSwbmTreeData() {
				this.$https.fetchPost('/master/getGoodsSWBMTree').then(res => {
					this.$nextTick(() => {
						_this.data = [{
							code: '0',
							parentCode: '',
							name: '全部',
							data: null,
							children: res.data.data
						}];
						_this.tree = 0;
						getCheckedAll(_this.data[0]);

						function getCheckedAll(e) {
							_this.tree++;
							if (e.children) {
								e.children.forEach(v => {
									getCheckedAll(v);
								});
							}
						}
					});
				});
			},
			toPoint(percent) {
				let str;
				if (percent.indexOf('%') === -1) {
					str = percent * 100;
					str += '%';
				} else {
					return percent
				}
				return str;
			},
			//表格筛选
			closeshaidiag() {
				this.shaidiag = false;
			},
			confirmfilter(e) {
				localStorage.setItem('Taxcodedictionarylist', JSON.stringify(e.nochooselist));
				localStorage.setItem('TaxcodedictionaryData', JSON.stringify(e.chooselist));
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
				this.$refs.tablebox.dout();
				this.tablekey++;
			}
		}
	};
</script>

<style scoped>
	.newstyle {
		padding: 4px;
		background: #e0eaf2;
		border-radius: 4px 4px 4px 4px;
		font-size: 12px;
		font-weight: 400;
		color: #0065b1;
	}

	.newbacktextstyle {
		font-size: 14px;
		font-weight: 400;
		color: #666666;
	}

	/deep/.el-table--small td {
		padding: 4px 0;
	}

	/* 	/deep/.el-table-column--selection{
		display: flex;
		align-items: center;
		justify-content: center;
		} */
	.plain {
		/* background-color: #b3d8ff; */
		background-color: #409eff;
		opacity: 0.7;
	}

	.blue {
		background-color: #409eff;
	}

	.top {
		width: 100%;
		border-bottom: 1px solid #ccc;
		padding: 10px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	/* /deep/ .el-breadcrumb__inner{
	color:black;
}
/deep/ .el-breadcrumb__separator{
	color:black;

} */

	.area1 {
		border-bottom: 1px solid #ccc;
		box-sizing: border-box;
	}

	.alledit {
		display: flex;
		justify-content: space-between;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}

	.move-btn {
		text-align: center;
		margin-top: 20px;
	}

	/deep/ .el-icon-d-arrow-right {
		transform: rotate(-90deg);
	}

	/deep/ .el-icon-d-arrow-left {
		transform: rotate(-90deg);
	}

	.text_slice {
		width: 120px;
		display: block;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.ara1 {
		width: 400px;
		background: #ffffff;
		box-sizing: border-box;
		padding: 24px 16px 16px 16px;
		border-radius: 8px 8px 8px 8px;
		margin-bottom: 16px;
	}

	.ara2 {
		width: -webkit-calc(100% - 416px);
		width: -moz-calc(100% - 416px);
		width: calc(100% - 416px);
		box-sizing: border-box;
		padding: 24px 16px 16px 16px;
		border-radius: 8px 8px 8px 8px;
		background: #ffffff;
		margin-bottom: 16px;
	}
</style>
>